<template>
  <el-menu class="navbar" mode="horizontal">
    <!--<hamburger class="hamburger-container" :toggleClick="toggleSideBar" :isActive="sidebar.opened"></hamburger> -->
    <div class="userinfo-container">
      <div style="display: inline;"><userinfo/><span style="padding: 10px; font-size: 12px;">Estado Actual del Sistema: {{ isIdle? "Inactivo": "Activo" }}</span></div>
    </div>
    <div class="breadcrumb-container">
      <breadcrumb></breadcrumb>
    </div>
    <div class="right-menu">
      <error-log class="errLog-container right-menu-item"></error-log>

      <!--
      <el-tooltip effect="dark" :content="$t('navbar.screenfull')" placement="bottom">
        <screenfull class="screenfull right-menu-item"></screenfull>
      </el-tooltip>

      <lang-select class="international right-menu-item"></lang-select>
      -->
      <solicitud-alert class="solicitud-container right-menu-item"></solicitud-alert>
      <reporte-alert class="alert-container right-menu-item"></reporte-alert>
      <el-dropdown class="avatar-container right-menu-item" trigger="click">
        <div class="avatar-wrapper">
          <img class="user-avatar" :src="avatar+'?imageView2/1/w/80/h/80'">
          <i class="el-icon-caret-bottom"></i>
        </div>
        <el-dropdown-menu slot="dropdown">
          <router-link to="/">
            <el-dropdown-item>
              {{$t('navbar.dashboard')}}
            </el-dropdown-item>
          </router-link>
          <el-dropdown-item divided>
            <span @click="logout" style="display:block;">{{$t('navbar.logOut')}}</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </el-menu>
</template>

<script>
import { mapGetters } from 'vuex'
import UserInfo from '@/components/UserInfo'
import Breadcrumb from '@/components/Breadcrumb'
// mport Hamburger from '@/components/Hamburger'
import ErrorLog from '@/components/ErrorLog'
import ReporteAlert from '@/components/ReporteVencidoAlert'
import SolicitudAlert from '@/components/SolicitudAlert'
// import Logo from './Logo'

export default {
  components: {
    userinfo: UserInfo,
    Breadcrumb,
    // Hamburger,
    ErrorLog,
    ReporteAlert,
    SolicitudAlert,
    // Logo
  },
  computed: {
    ...mapGetters([
      'sidebar',
      'name',
      'avatar'
    ]),
    isIdle () {
      return this.$store.state.idleVue.isIdle
    }
  },
  methods: {
    toggleSideBar () {
      this.$store.dispatch('toggleSideBar')
    },
    logout () {
      this.$store.dispatch('LogOut').then(() => {
        location.reload()// In order to re-instantiate the vue-router object to avoid bugs
      })
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.navbar {
  height: 50px;
  line-height: 50px;
  border-radius: 0px !important;
  .hamburger-container {
    line-height: 58px;
    height: 50px;
    float: left;
    padding: 0 10px;
  }
  .breadcrumb-container{
    float: left;
  }
  .userinfo-container {
    float: left;
  }
  .errLog-container {
    display: inline-block;
    vertical-align: top;
  }
  .alert-container {
    display: inline-block;
    width: 40px;
  }
  .right-menu {
    float: right;
    height: 100%;
    &:focus{
     outline: none;
    }
    .right-menu-item {
      display: inline-block;
      margin: 0 8px;
    }
    .screenfull {
      height: 20px;
    }
    .international{
      vertical-align: top;
    }
    .theme-switch {
      vertical-align: 15px;
    }
    .avatar-container {
      height: 50px;
      margin-right: 30px;
      .avatar-wrapper {
        cursor: pointer;
        margin-top: 5px;
        position: relative;
        .user-avatar {
          width: 40px;
          height: 40px;
          border-radius: 10px;
        }
        .el-icon-caret-bottom {
          position: absolute;
          right: -20px;
          top: 25px;
          font-size: 12px;
        }
      }
    }
  }
}
</style>
